import type { ReactNode } from 'react';
import { useJobMobile } from './use-job-mobile';
import { PhoneScanIntro } from './PhoneScanIntro';
import { MobilePeople } from './MobilePeople';
import { MobileOptions } from './MobileOptions';
import './email-sheet.css';
import './mobile-sheet.css';
import './phone-scan.css';

/** The section's name, in the setup's list and as its title: what people do, not the device. */
export const PHONE_SCAN_TITLE = 'Scan from a phone';

/**
 * The job setup's Scan from a phone section (docs/engineering/mobile-capture.md, section 13; Dustin
 * 2026-10-04: who sends from phones is the job's setup, not Add pages): what it is as a drawing and one
 * line, how as three steps, who can send, and the options under one closed group. The company's own
 * people need nothing here: signed in on the app, they send to every job they upload to. Renders nothing
 * when the workbench is not on a Paige job.
 */
export function PaigePhoneScanSetup(): ReactNode {
  const mobile = useJobMobile();
  if (mobile.mobile === null) return null;
  return (
    <>
      <header className="setup-export-heading">
        <h2>{PHONE_SCAN_TITLE}</h2>
      </header>
      <div className="paige-phone-scan" aria-label={PHONE_SCAN_TITLE}>
        <PhoneScanIntro listed={mobile.mobile?.storeListed !== false} />
        <MobilePeople state={mobile} />
        <MobileOptions state={mobile} />
        {mobile.error && (
          <p className="paige-email-sheet-error" role="alert">
            {mobile.error}
          </p>
        )}
      </div>
    </>
  );
}
